export const ippfauthtoken = 'ippfauthtoken';
export const USER_ID = 'USER_ID';
export const EMAIL = 'EMAIL';
export const FIRST_NAME = 'FIRST_NAME';
export const LAST_NAME = 'LAST_NAME';
export const USER_TYPE = 'USER_TYPE';